import { ref } from 'vue'

/**
 * h3live 房间列表与嵌入页 origin，来自宿主自己的 /api/sk/h3live/rooms（前端不持有 h3live 配置）。
 * 同一种界面语言只真正请求一次，导航入口、首页区块、/live 页面共用同一份；
 * 直播间名按语言翻译（请求头 x-locale 由 api-sdk 自动带上），所以换了语言就按新语言再取一次。
 * 请求失败按「没接 h3live」处理（embedOrigin 空、列表空）：服务端已把 h3live 抖动兜成空列表，
 * 这里再失败只可能是宿主自己不可用，首页不为此出错误横幅。
 *
 * @param {{ h3live: { rooms(): Promise<{ embed_origin: string, channels: object[] }> } }} api
 */
export function createH3liveRooms(api) {
  if (typeof api?.h3live?.rooms !== 'function') throw new Error('createH3liveRooms: api.h3live.rooms is required')
  const embedOrigin = ref('')
  const channels = ref([])
  const ready = ref(false)
  let loadedLocale = null
  let loadTask = null

  /** @param {string} locale 当前界面语言；和上次取的一样就复用 */
  function load(locale) {
    if (locale === loadedLocale) return loadTask
    loadedLocale = locale
    loadTask = api.h3live.rooms()
      .then(rooms => {
        // 连着切两次语言时，先发出的请求可能后回来：只认最后要的那种语言
        if (locale !== loadedLocale) return
        embedOrigin.value = rooms.embed_origin
        channels.value = rooms.channels
      })
      .catch(error => {
        if (locale !== loadedLocale) return
        console.warn('[visual-game] h3live rooms unavailable', error)
        embedOrigin.value = ''
        channels.value = []
      })
      .finally(() => {
        ready.value = true
      })
    return loadTask
  }

  return { embedOrigin, channels, ready, load }
}
